import { Grid, Tooltip} from "@mui/material";

export function getPoStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        podate:{
            name:'podate',
            label:'PO Date',
            value:'',
            error:false,
            errorMessage:'You must enter PO Date',
            required:true,
            fieldtype:'date'
        },
        partyid:{
            name:'partyid',
            label:'Party ID',
            value:'',
            error:false,
            errorMessage:'You must enter Party ID',
            required:true,
            fieldtype:'ID'
        },
        partyname:{
            name:'partyname',
            label:'Party Name',
            value:'',
            error:false,
            errorMessage:'You must enter Party Name',
            required:true,
            fieldtype:'string'
        },
        povalue:{
            name:'povalue',
            label:'PO Value',
            value:'',
            error:false,
            errorMessage:'You must enter PO Value',
            required:true,
            fieldtype:'double'
        },
        ordervalue:{
            name:'ordervalue',
            label:'Order Value',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        popath:{
            name:'popath',
            label:'PO Path',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'podate', headerName: 'PO Date', width:150 },
        { field: 'partyname', headerName: 'Party Name', width:250 },
        { field: 'povalue', headerName: 'PO Value', width:150 },
        { field: 'ordervalue', headerName: 'Order Value', width:100 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['podate']:{
          ...formValues['podate'],
          value:data.podate,
        },['partyid']:{
          ...formValues['partyid'],
          value:data.partyid,
        },['partyname']:{
          ...formValues['partyname'],
          value:data.partyname,
        },['povalue']:{
          ...formValues['povalue'],
          value:data.povalue,
        },['ordervalue']:{
          ...formValues['ordervalue'],
          value:data.ordervalue,
        },['popath']:{
          ...formValues['popath'],
          value:data.popath,
        },['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },
      })
}